import {createSelector} from 'reselect';

import FEATURE_FLAGS from '../../../utils/featureFlags';
import {featureFlagsSelector} from '../selectors';

const showImportantInfoModalSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.event.importantInfoModal]
);

const showApplePaySelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.payment.applePay]
);

const isPayPalPayLaterEnabledSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.common.paypal.payLater]
);

const isCBTModuleEnabledSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.common.cbtModule.show]
);

const isRedirectModalEnabledSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.common.redirectModal.show]
);

const hideCbtEventsSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.common.hideCbtEvents]
);

const showByoMapSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.byo.map.show]
);

const showPopularInCountrySelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.browse.popularInCountry]
);

const isNewXoExperienceEnabledSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.byo.newXoExperience]
);

const showBrokerInfoSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.event.brokerInfo.show]
);

const showBrokerInfoDSASelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.event.brokerInfo.dsa.show]
);

const priceIncludeFeesSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.priceIncludeFees]
);

const hideTicketBisPriceSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.browse.hideTicketBisPrice]
);

const showVenueCountryFlagSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.showVenueCountryFlag]
);

export {
  showImportantInfoModalSelector,
  showApplePaySelector,
  isPayPalPayLaterEnabledSelector,
  isCBTModuleEnabledSelector,
  isRedirectModalEnabledSelector,
  hideCbtEventsSelector,
  showByoMapSelector,
  showPopularInCountrySelector,
  isNewXoExperienceEnabledSelector,
  showBrokerInfoSelector,
  showBrokerInfoDSASelector,
  priceIncludeFeesSelector,
  hideTicketBisPriceSelector,
  showVenueCountryFlagSelector,
};
